import React from "react";

export const Symptoms01: React.FC = () => {
  return (
    <div id="symptoms" className="symptoms01-section">
      <div className="moreinfo-container">
        <div className="moreinfo-content">
          <div className="moreinfo-left">
            <h2 className="moreinfo-title moreinfo-title-pink moreinfo-title-left">Síntomas</h2>
            
            <p className="moreinfo-text">
              Los síntomas de la endometriosis <span className="moreinfo-highlight-blue">son muy variados y por supuesto
              que dependen de la persona a la que afecte.</span> De todas formas te vamos a contar cuáles son los más frecuentes
              para que los tengas presentes:
            </p>
            
            <ul className="symptoms01-list">
              <li className="symptoms01-list-item">Dolor severo en las menstruaciones.</li>
              <li className="symptoms01-list-item">Dolor pélvico y abdominal, a menudo crónico. Esto significa tenerlo por más de 6 meses no asociado al período.</li>
              <li className="symptoms01-list-item">Trastornos, dolor o disfunción intestinal o urinaria. Por ejemplo estreñimiento, diarrea, problemas al orinar, etc.</li>
              <li className="symptoms01-list-item">Dolor con las relaciones sexuales o penetración.</li>
              <li className="symptoms01-list-item">Dolor al insertar una copa menstrual o un tampón.</li>
              <li className="symptoms01-list-item">Infertilidad, pérdida de embarazos.</li>
              <li className="symptoms01-list-item">Dolor en espalda baja y pierna.</li>
              <li className="symptoms01-list-item">Fatiga crónica.</li>
            </ul>
          </div>
          
          <div className="moreinfo-right">
            <h2 className="moreinfo-title moreinfo-title-pink moreinfo-title-left symptoms01-title-hidden" aria-hidden="true">Síntomas</h2>
            
            <p className="moreinfo-text">
              El dolor y los síntomas pueden empeorar o incluso cronificarse con el tiempo, a medida que las lesiones se hacen más profundas y fibróticas.
            </p>
            
            <p className="moreinfo-text">
              Como consecuencia, pueden aparecer infertilidad, disfunción vesical o intestinal, relaciones sexuales dolorosas y muchos otros problemas físicos
              y de calidad de vida. Las investigaciones actuales indican que hay una preponderancia del medio inflamatorio y una hiper inervación implicados en la
              fisiopatología del dolor en quienes padecen la enfermedad, y que los pacientes con dolor pélvico crónico demuestran habitualmente una mayor sensibilidad
              al dolor incluso en zonas no pélvicas.
            </p>
            
            <div className="moreinfo-image-container">
              <img
                src="img/symptoms.png"
                className="moreinfo-image"
                alt="Síntomas de endometriosis"
              />
            </div>
          </div>
        </div>
        
        <p className="moreinfo-footer">
          <strong>Fuente:</strong> <a href="https://www.centerforendo.com/" target="_blank" rel="noopener noreferrer">Center for Endometriosis Care</a>
          <br /> <br />
        </p>
      </div>
    </div>
  );
};